import { z } from 'zod';

import { headerTypeSchema, templateCategorySchema, templateStatusSchema } from './enums.js';

export const templateDtoSchema = z.object({
  id: z.string(),
  metaTemplateId: z.string().nullable(),
  name: z.string(),
  language: z.string(),
  category: templateCategorySchema,
  status: templateStatusSchema,
  headerType: headerTypeSchema,
  bodyParamCount: z.number().int(),
  bodyText: z.string().nullable(),
  rejectedReason: z.string().nullable(),
  syncedAt: z.string().datetime(),
});
export type TemplateDto = z.infer<typeof templateDtoSchema>;

export const templateSyncResultSchema = z.object({
  fetched: z.number().int(),
  created: z.number().int(),
  updated: z.number().int(),
  /** Local rows Meta no longer returns, marked DELETED by the sync. */
  removed: z.number().int(),
});
export type TemplateSyncResult = z.infer<typeof templateSyncResultSchema>;

/** A template is usable for sending only when Meta has approved it. */
export function isTemplateSendable(status: string): boolean {
  return status === 'APPROVED';
}

/** Header types that require a media file on the send request. */
export function headerRequiresMedia(headerType: string): boolean {
  return headerType === 'DOCUMENT' || headerType === 'IMAGE';
}
